import { ReactNode, VFC } from "react";
import { Button } from "@chakra-ui/react";

type Props = {
  children: ReactNode;
  disabled?: boolean;
  isLoading?: boolean;
  type?: string;
  id?: string;
  size?: string;
  // eslint-disable-next-line
  onClick: any;
};

export const ListButton: VFC<Props> = (props) => {
  const {
    children,
    disabled = false,
    isLoading = false,
    type = "btn",
    id = "",
    size = "xs",
    onClick
  } = props;

  return (
    <Button
      id={id ? id : type}
      bg={type === "ng" ? "gray.200" : type === "ok" ? "red.500" : type === "user" ? "blue.300" : "orange.400" }
      color={type === "ng" ? "black" : "white" }
      size={size}
      isDisabled={disabled || isLoading}
      isLoading={isLoading}
      _hover={{ opacity: 0.8 }}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
